<template>
  <view class="physicalGood">
    <image class="goods-image" :src="goodItem[imgUrl]" mode="widthFix" />
    <img :src="defaultImg" v-if="!goodItem.stock" class="defaultImgs" alt="">
    <view class="item-box">
      <view class="item-title">
        <view v-if="goodItem.promotionPriceList[0].priceOriginal == 5" class="mstitle">秒杀</view>
        {{ goodItem[goodName] }}
      </view>
      <slot name="tool"></slot>
      <!-- <view class="zkhf" v-if="goodItem.promotionPriceList[0].priceOriginal == 2 && level == 3">
        <img :src="baseUrl + '/opmallh5/zk1.png'" class="zkhfImg" mode="widthFix" />
      </view>
      <view class="zkhf" v-if="goodItem.promotionPriceList[0].priceOriginal == 2 && level == 4">
        <img :src="baseUrl + '/opmallh5/zk2.png'" class="zkhfImg" mode="widthFix" />
      </view>
      <view class="zkhf" v-if="goodItem.promotionPriceList[0].priceOriginal == 2 && level == 5">
        <img :src="baseUrl + '/opmallh5/zk3.png'" class="zkhfImg" mode="widthFix" />
      </view> -->
      <!-- <view class="ysbtn" v-if="goodItem.promotionPriceList[0].priceOriginal != 5">
        已售:{{ goodItem.salesCount<1000?goodItem.salesCount:"1k+" }}
      </view> -->
      <view class="mshf" v-if="goodItem.promotionPriceList[0].priceOriginal == 5">
        <view class="mshfs">
          即将恢复 ￥{{ fen2yuan(goodItem.price) }}
        </view>
      </view>
      <view class="msbtn" v-if="goodItem.promotionPriceList[0].priceOriginal == 5">
        立即抢
      </view>
      <view style="margin-top:10rpx;">
        <view style="display:flex;align-items:center">
        <view style="color:#e83852;margin-bottom:10rpx;margin-right:20rpx;color:#8A38F5;border:solid #8A38F5 2rpx;padding:0rpx 4rpx;font-size:24rpx;" v-if="goodItem.tagName">{{goodItem.tagName}}</view>
        <view style="color:#e83852;margin-bottom:10rpx;"  v-if="goodItem.promotionPriceList[0].priceOriginal==6">权益专享</view>
      </view>
        <view style="display:flex;align-items:center">
          <Price :price="goodItem.promotionPriceList[0].price" :fontSize="18"
        :showlev="goodItem.promotionPriceList[0].priceOriginal" :moneyColor='textColor'></Price>
        <view class="ss-m-r-16"
        v-if="goodItem.marketPrice>=goodItem.promotionPriceList[0].price"
         style="
									color: #a4a4a4;
									font-size: 24rpx;
                  padding-bottom:12rpx;
                  padding-left:10rpx;
									text-decoration: line-through;
									transform: translateY(4rpx);">
                  ￥{{fen2yuan(goodItem.marketPrice)}}
        </view>  
      </view>
      </view>
    </view>
    <view class="tmLogo" v-if="goodItem.supplierType == 865">天猫</view>
    <view class="wphLogo" v-if="goodItem.supplierType == 3">唯品会</view>
  </view>
</template>
<script>
import Price from "@/components/price";
import { fen2yuan } from "../../sheep/hooks/useGoods";

const baseUrl = import.meta.env.SHOPRO_BASE_IMG_URL;
export default {
  data() {
    return {
      baseUrl: baseUrl,
      level: 1,
      current: 0,
      defaultImg: `${baseUrl}/static/images/author/replenish_icon.png`
    };
  },

  components: {
    Price,
  },
  props: {
    textColor: {
      type: String,
      default: '#333'
      // default: '#202020'
    },
    isqy: { //是不是蛋糕叔叔商品
      type: Boolean,
      default: false,
    },
    goodItem: {
      type: Object,
      default: {},
    },
    imgUrl: {
      type: String,
      default: 'picUrl'
    },
    goodName: {
      type: String,
      default: 'name'
    },
    price: {
      type: String,
      default: 'vipPrice'
    },
  },
  methods: {
    fen2yuan,
    click_item(e) {
      this.swiperDotIndex = e;
    },
  },
  mounted() {
    const userInfo = JSON.parse(uni.getStorageSync('user-store')) || {}
    this.level = userInfo.userInfo.level.level
  }
};
</script>
<style lang="scss" scoped>
.physicalGood {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  .defaultImgs {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .goods-image {
    width: 100%;
    height: 168px;
    border-radius: 16rpx 16rpx 0 0;
    overflow: hidden;
  }

  .item-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    padding: 0 16rpx 16rpx;
    padding-bottom:10rpx;
    box-sizing: border-box;
  }

  .item-title {
    width: 100%;
    text-align: left;
    font-size: 28rpx;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin: 8rpx 0;
  }

  .tmLogo {
    position: absolute;
    top: 0;
    left: 0;
    width: 44px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background: #00CD00;
    border-radius: 8px 0px 8px 0px;
    font-size: 12px;
    color: #fff;
  }

  .mstitle {
    display: inline-block;
    background: linear-gradient(to bottom, #fa0b31, #ff5a4a);
    color: #fff;
    padding: 4rpx 8rpx;
    font-size: 24rpx;
    border-radius: 10rpx;
  }

  .zkhf {
    display: flex;
    align-items: center;
    width: 200rpx;
    color: #65532c;
    margin-bottom: 10rpx;

    .zkhfImg {
      height: 34rpx;
      // width: 120rpx;
    }
  }

  .mshf {
    display: flex;

    .mshfs {
      border-radius: 10rpx;
      border: solid 2rpx #fee1e6;
      color: #fb1b41;
      margin-top: 6rpx;
      font-family: Douyin;

      font-size: 20rpx;
      text-align: center;
      padding: 2rpx 8rpx;
      margin-bottom: 10rpx;
    }


  }

  .ysbtn {
    position: absolute;
    font-size: 24rpx;
    right: 20rpx;
    bottom: 17rpx;
    color: #c4c4c4;
  }

  .msbtn {
    background: linear-gradient(to bottom, #ff5a4a, #fa0b31);
    color: #fff;
    border-radius: 200rpx;
    // width: 100rpx;
    text-align: center;
    padding: 6rpx 12rpx;
    padding-bottom: 8rpx;
    position: absolute;
    font-size: 24rpx;
    right: 10rpx;
    bottom: 20rpx;
  }

  .wphLogo {
    position: absolute;
    top: 0;
    left: 0;
    width: 44px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background: linear-gradient(137deg, #FF74A2 0%, #FF6095 22%, #FF377A 100%);
    border-radius: 8px 0px 8px 0px;
    font-size: 11px;
    color: #fff;
  }
}
</style>
